import unregisterStudentTemplate from '../unregister-student/unregister-student.html';
import './select-student-to-deregister.scss';
import template from './select-student-to-deregister.html';

export class SelectStudentToDeregisterController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $state, $rootScope, AttendanceService, CategoryOfDepartureService
  ) {
    this.$rootScope = $rootScope;
    this.$log = $log;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.AttendanceService = AttendanceService;
    this.CategoryOfDepartureService = CategoryOfDepartureService;
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  selectStudent(student) {
    this.$mdDialog.show({
      resolve: {
        attendances: () => {
          return this.AttendanceService.getRegistrations({studentId: student.studentAssignedToCardOwner.scrStudentId}).then(response => {
            return response;
          }).catch(error => {
            this.$mdDialog.show(
              this.$mdDialog.extendError({
                locals: {error}
              })
            );
          });
        },
        categoriesOfDeparture: () => {
          return this.CategoryOfDepartureService.getAll().then(response => {
            return response;
          });
        }
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'UnregisterStudentController',
      locals: {
        departureCategory: student.groupType === 5 || student.groupType === 9 ? 3 : 1,
        comment: student.groupType === 5 || student.groupType === 9 ? `Odebrano przez: ${student.firstNameCardOwner} ${student.lastNameCardOwner}` : 'Uczeń samodzielnie opuścił świetlicę'
      },
      template: unregisterStudentTemplate,
      disableParentScroll: true,
      clickOutsideToClose: true
    }).then(() => {
      this.$rootScope.$broadcast('dashboard.config.unregister');
    });
  }
}

export const SelectStudentToDeregister = {
  bindings: {
    nextStep: '&',
    students: '=',
    cardId: '@',
    access: '=',
    currentClassRoom: '=',
    classRooms: '='
  },
  controller: SelectStudentToDeregisterController,
  template
};
